import { toApiError } from '@/lib/agentApiServices/utils'
import type { ApiClient, ApiService } from '@/lib/apiClient'
import { formatDateISO } from '@/utils/date'

interface Args {
  startDate: Date
  endDate: Date
  userId: string
  customerId: string
}

type Response = Blob

export type GetActivitiesforUserCsvApiService = ApiService<Args, Response>

type GetActivitiesForUserCsvUrlArgs = {
  customerId: string
  userId: string
  startDate: Date
  endDate: Date
}

export const toEncodedIsoDate = (date: Date): string =>
  encodeURIComponent(formatDateISO(date))

export const getActivitiesForUserCsvUrl = ({
  startDate,
  endDate,
  userId,
  customerId,
}: GetActivitiesForUserCsvUrlArgs): string =>
  `dashboard/activities/csv?startDate=${toEncodedIsoDate(
    startDate,
  )}&endDate=${toEncodedIsoDate(endDate)}&userId=${userId}&customerId=${customerId}`

const createGetActivitiesForUserCsvApiService =
  (apiClient: ApiClient): GetActivitiesforUserCsvApiService =>
  ({ startDate, endDate, userId, customerId }) =>
    apiClient
      .get(
        getActivitiesForUserCsvUrl({
          startDate,
          endDate,
          userId,
          customerId,
        }),
      )
      .then(({ data }) => data)
      .catch(error => Promise.reject(toApiError(error)))

export default createGetActivitiesForUserCsvApiService
